// extracted by mini-css-extract-plugin
module.exports = {"NewGroupBlock":"NewGroup_NewGroupBlock__1B1La"};